/**
 * Rolagem do app: no app instalado (iOS/Android standalone) o layout da loja
 * no celular rola dentro de <main data-scroll-container> e o documento fica
 * parado (bug do WebKit 297779: a camada fixed se desloca quando o documento
 * rola depois do teclado). Fora disso, a rolagem continua na janela.
 */

export const APP_SHELL_CLASS = 'app-shell';
const SELECTOR = '[data-scroll-container]';

export function isAppShellActive(): boolean {
  return typeof document !== 'undefined' &&
    document.documentElement.classList.contains(APP_SHELL_CLASS);
}

/** Container de rolagem ativo: o <main> do shell ou a janela. */
export function getScrollContainer(): HTMLElement | Window {
  if (typeof window === 'undefined') return undefined as unknown as Window;
  if (isAppShellActive()) {
    const el = document.querySelector<HTMLElement>(SELECTOR);
    if (el) return el;
  }
  return window;
}

export function getScrollTop(): number {
  const c = getScrollContainer();
  if (!c) return 0;
  return c instanceof Window ? c.scrollY : c.scrollTop;
}

export function scrollContainerTo(top: number, behavior: ScrollBehavior = 'auto'): void {
  const c = getScrollContainer();
  if (!c) return;
  c.scrollTo({ top, behavior });
}

export function scrollToTop(behavior: ScrollBehavior = 'auto'): void {
  scrollContainerTo(0, behavior);
}

/**
 * Ouve a rolagem do container ativo (janela ou <main> do shell), mesmo que o
 * shell seja ligado/desligado depois do registro. Devolve a função de remoção.
 */
export function addScrollListener(listener: () => void): () => void {
  if (typeof document === 'undefined') return () => {};
  const handler = (event: Event) => {
    const t = event.target;
    if (t === document || t === document.documentElement || t === window) return listener();
    if (t instanceof HTMLElement && t.matches(SELECTOR)) listener();
  };
  document.addEventListener('scroll', handler, { capture: true, passive: true });
  return () => document.removeEventListener('scroll', handler, { capture: true } as EventListenerOptions);
}
